export const PLANS = [
  {
    id: 'monthly',
    label: 'Monthly',
    price: '$6',
    period: '/month',
    billedAs: 'Billed monthly',
    perMonth: '$6',
    badge: null,
  },
  {
    id: 'annual',
    label: 'Annual',
    price: '$50',
    period: '/year',
    billedAs: '$4.17/mo · Save 31%',
    perMonth: '$4.17',
    badge: 'Best value',
  },
];
